import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import CartDrawer from "@/components/CartDrawer";
import { trackPageView } from "@/lib/metaPixel";

// Fires Meta Pixel PageView on every client-side route change
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <RouteTracker />
        <div className="App dark">
          <div className="grain-overlay" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:handle" element={<ProductDetail />} />
          </Routes>
          <CartDrawer />
        </div>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#111826",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#F3EEE3",
          },
        }}
      />
    </CartProvider>
  );
}

export default App;
